import { FC, useEffect, useState } from "react";
import { IControlAttributes } from "../../../../base/models";
import { useGetProperties } from "../../../../base/hooks";
import { ControlType, Property, PropertyType } from "../../../../base/types";
import { Registry } from "../../../../base/register";
import { Spinner } from "../../../../widgets";
import { useGetOwnerLookupLabel } from "./useGetOwnerLookupLabel";

export const OwnerNameLookupComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const value: string | undefined = properties[Property.InitValue]
    const { getLookupLabel, isLoading } = useGetOwnerLookupLabel()
    const [name, setName] = useState<string>()

    useEffect(() => {
        getLookupLabel({value })
            .then(name => setName(name))
        // eslint-disable-next-line
    }, [ value])

    return (
        
        <label className={className}>
            <Spinner show={isLoading} />
            {name}
        </label>
        )
}

Registry.addControl({
    id: "bcbc1e3d-0eb6-4495-a608-bb27cd37fea9",
    name: "Owner Name Lookup",
    type: ControlType.OwnerNameLookup,
    properties: [
        { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    ],
    component: OwnerNameLookupComponent
})
